var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M12.1836 19.8984C11.5873 19.8984 11.1039 19.415 11.1039 18.8187V4.97815C11.1039 4.38184 11.5873 3.89844 12.1836 3.89844C12.7799 3.89844 13.2633 4.38184 13.2633 4.97815V18.8187C13.2633 19.415 12.7799 19.8984 12.1836 19.8984ZM5.25784 12.9727C4.66455 12.9727 4.18359 12.4917 4.18359 11.8984C4.18359 11.3051 4.66455 10.8242 5.25784 10.8242H19.1093C19.7026 10.8242 20.1836 11.3051 20.1836 11.8984C20.1836 12.4917 19.7026 12.9727 19.1093 12.9727H5.25784Z",
    fill: "#e4e4e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.09d4dce456f385fc3c6056f183662c62.svg";
export { ForwardRef as ReactComponent };